import { HttpInterceptorFn } from '@angular/common/http';
import { simulateFailureInterceptor } from './simulate-failure.interceptor';

/**
 * The simulate-failure QA switch, as the list `app.config.ts` spreads into its
 * interceptor chain. This is the ONLY file `app.config.ts` imports for the
 * feature, which is what lets the production build drop all of it.
 *
 * `angular.json` → `configurations.production.fileReplacements` swaps this file
 * for `simulate-failure.registration.production.ts` (an empty list), so the
 * interceptor, the scenario utility and the `__simulateSrv` console helper are
 * not reachable from the production bundle at all. A conditional on
 * `environment.production` did not achieve that: it was measured to leave the
 * code in the bundle.
 *
 * Staging, UAT and development keep this real list; the runtime flag
 * `simulateFailureEnabled` then decides whether it does anything.
 */
export const SIMULATE_FAILURE_INTERCEPTORS: readonly HttpInterceptorFn[] = [simulateFailureInterceptor];
